import React, { useState } from 'react';
import { MenuIcon, UserIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Medical Care',
    href: '#services'
  }, {
    name: 'Mental Wellness',
    href: '#mental-wellness'
  }, {
    name: 'SYMBIS Coaching',
    href: '#symbis-coaching'
  }, {
    name: 'About Us',
    href: '#about-us'
  }, {
    name: 'Contact Us',
    href: '#contact-us'
  }];
  return <header className="sticky top-0 z-50 w-full bg-[#F8F9FA]/95 backdrop-blur-sm border-b border-[#588157]/10" data-id="element-42">
      <div className="container mx-auto px-4 h-20 flex items-center justify-between" data-id="element-43">
        <a href="#home" className="flex items-center gap-2 hover:opacity-80 transition-opacity" data-id="element-44">
          <div className="w-10 h-10 bg-[#588157] rounded-full flex items-center justify-center" data-id="element-45">
            <span className="text-[#F8F9FA] font-serif text-xl font-bold" data-id="element-46">
              G
            </span>
          </div>
          <div className="hidden sm:block" data-id="element-47">
            <h1 className="text-[#588157] font-serif font-bold leading-none text-lg" data-id="element-48">
              Global Restorative
            </h1>
            <p className="text-[#588157]/70 text-[10px] uppercase tracking-widest" data-id="element-49">
              Health & Wellness LLC
            </p>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-50">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-[#1A374D] hover:text-[#588157] font-medium transition-colors text-sm" data-id="element-51">
              {link.name}
            </a>)}
        </nav>

        <div className="flex items-center gap-4" data-id="element-52">
          <button className="hidden sm:flex items-center gap-2 px-4 py-2 text-[#588157] font-semibold border-2 border-[#588157] rounded-full hover:bg-[#588157] hover:text-white transition-all text-sm" data-id="element-53">
            <UserIcon size={16} data-id="element-54" />
            <span data-id="element-55">Patient Portal</span>
          </button>
          <button onClick={() => window.location.hash = '#contact-us'} className="px-6 py-2 bg-[#D4A373] text-white font-semibold rounded-full hover:bg-[#c29263] transition-all shadow-md text-sm" data-id="element-56">
            Book Consultation
          </button>
          <button className="lg:hidden p-2 text-[#588157]" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-57">
            {isMenuOpen ? <XIcon size={24} data-id="element-58" /> : <MenuIcon size={24} data-id="element-59" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Overlay */}
      {isMenuOpen && <div className="lg:hidden absolute top-20 left-0 w-full bg-white border-b border-[#588157]/10 shadow-xl py-6 px-4 animate-in fade-in slide-in-from-top-4" data-id="element-60">
          <nav className="flex flex-col gap-4" data-id="element-61">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMenuOpen(false)} className="text-lg font-serif text-[#1A374D] hover:text-[#588157] py-2 border-b border-gray-50" data-id="element-62">
                {link.name}
              </a>)}
            <button className="flex items-center justify-center gap-2 w-full mt-4 px-4 py-3 text-[#588157] font-semibold border-2 border-[#588157] rounded-xl" data-id="element-63">
              <UserIcon size={18} data-id="element-64" />
              <span data-id="element-65">Patient Portal</span>
            </button>
          </nav>
        </div>}
    </header>;
}